import { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemText } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { IReduxState } from 'app/store';
import { setDeletePromptParams } from 'features/GridSlice';
import { LoginService } from 'login/services/login.service';
import { IconMenu } from 'common/components/Icons/IconMenu/IconMenu';
import { PopUp } from 'common/components/popUp/PopUp';
import { AddUserPopUp } from '../UserManagementActions/AddUserPopUp/AddUserPopUp';
import { createPortal } from 'react-dom';

export function UserActionsDropdown(props: any) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [editPopupVisible, setEditPopupVisible] = useState<boolean>(false);
  const dispatch = useDispatch<any>();
  const { user } = useSelector((state: IReduxState) => state.login);

  const isDisabled = (): boolean => {
    if (LoginService.isViewer(user) || user.email === props.params.row.email || !props.params.row?.actions?.is_deletable) {
      return true;
    }
    return false;
  };

  const handleOnClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDeleteClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();

    if (isDisabled()) {
      return;
    }

    const id = props.params.id;
    const index = props.params.api.getRowIndex(id);
    const category = props.source.category;
    const tab = props.source.tab;

    dispatch(
      setDeletePromptParams({
        category: category,
        tab: tab,
        index: index,
        ids: [id],
        message: getDeleteMessageByCategory()
      })
    );

    setAnchorEl(null);
  };

  const handleEditClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    if (isDisabled()) {
      return;
    }
    setEditPopupVisible(true);
    setAnchorEl(null);
  };

  const getDeleteMessageByCategory = (): string => {
    switch (props.source.tab) {
      case 'manage-fqdns':
        return "Are you sure you would like to remove this asset and it's subdomains?";
      case 'subsidiaries':
        return 'Are you sure you would like to remove this subsidiary?';
      default:
        return 'Are you sure you would like to remove this item?';
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton
        size="small"
        onClick={handleOnClick}
        sx={{
          color: '#5D6576',
          '&:hover': {
            backgroundColor: '#f6f8ff'
          }
        }}
      >
        <IconMenu active={open} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        PaperProps={{
          sx: {
            minWidth: 120,
            boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
            border: '1px solid #ecedff'
          }
        }}
      >
        <MenuItem
          onClick={handleDeleteClick}
          disabled={isDisabled()}
          sx={{
            fontSize: '13px',
            color: isDisabled() ? '#ccc' : '#5D6576',
            '&:hover': {
              backgroundColor: isDisabled() ? 'transparent' : '#f6f8ff'
            }
          }}
        >
          <ListItemText primary="Delete" />
        </MenuItem>
        <MenuItem
          onClick={handleEditClick}
          disabled={isDisabled()}
          sx={{
            fontSize: '13px',
            color: isDisabled() ? '#ccc' : '#5D6576',
            '&:hover': {
              backgroundColor: isDisabled() ? 'transparent' : '#f6f8ff'
            }
          }}
        >
          <ListItemText primary="Edit" />
        </MenuItem>
      </Menu>
      {editPopupVisible && createPortal(
        <PopUp visible={editPopupVisible} setVisible={() => setEditPopupVisible(false)}>
          <AddUserPopUp
            mode="edit"
            userData={props.params.row}
            rowId={props.params.id}
            onClose={() => setEditPopupVisible(false)}
          />
        </PopUp>,
        document.body
      )}
    </>
  );
}
